import {Component, OnInit} from '@angular/core';
import moment from 'moment';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {EditorComponent} from '@shared/editor/editor.component';

@Component({
    selector: 'app-report-email-modal',
    templateUrl: './report-email-modal.component.html',
    styleUrls: ['./report-email-modal.component.scss'],
    imports: [
        FormsModule,
        EditorComponent
    ]
})
export class ReportEmailModalComponent implements OnInit {
  include_attachment: boolean = true;
  advisory: any;
  subjectText: string;
  bodyText: string;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    var release_date = moment(this.advisory.actual_startdate).add(1, 'day');
    this.subjectText = 'Beach Advisory Report for ' + release_date.format('MMMM Do, YYYY');
    this.bodyText = 'Please find the beach advisory reports for ' + release_date.format('MMMM Do, YYYY') + ' attached.' +
      '<br/><br/>' +
      'Sincerly,<br/>' +
      'Guam EPA EMAS';
  }


}
